import { getIconPickerColorStyle } from '#pplx/frontend/aether-contrib/components/IconPicker/colors/index.js';
import { getSpaceIconId } from '#pplx/frontend/apps/ask/collections/getSpaceIconId.js';
import { unifiedEmojiToString } from '#pplx/frontend/common/unifiedEmojiToString.js';
import { FOLDER_EMOJI } from '#pplx/frontend/components/utils/consts.js';
import { isOwnerDefaultBookmarks } from '#pplx/frontend/components/utils/PrivacyUtils.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
function resolveFallbackPresentation(space) {
    const emoji = space.appearance?.emoji ?? space.emoji;
    if (emoji != null && emoji !== FOLDER_EMOJI && unifiedEmojiToString(emoji) != null) {
        return { type: 'emoji', emoji };
    }
    if (space.user_permission != null && isOwnerDefaultBookmarks(space.user_permission)) {
        return { type: 'bookmark', icon: $icon('bookmark'), color: 'light' };
    }
    return { type: 'folder', icon: $icon('folder-filled'), color: 'light' };
}
export function resolveSpaceIcon(space, colorScheme = 'light') {
    if (space.appearance?.icon != null) {
        return {
            type: 'appearance-icon',
            iconId: getSpaceIconId(space.appearance.icon),
            colorStyle: getIconPickerColorStyle(space.appearance?.color, colorScheme),
            fallback: resolveFallbackPresentation(space),
        };
    }
    return resolveFallbackPresentation(space);
}
//# sourceMappingURL=resolveSpaceIcon.js.map